var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-7xl mx-auto sm:px-6 lg:px-8 my-10"},[_c('h1',{staticClass:"my-5 text-white text-3xl font-bold"},[_vm._v("Subscribers")]),_c('usersGrid',{attrs:{"users":_vm.users}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }